<template>
  <b-card>
    <div>
      <span
        v-if="modalID"
        class="font-weight-bold"
        style="font-size: 20px;"
      >{{ locationName }}
        <b-link
          v-b-modal="'editLocation' + modalID"
          title="แก้ไขชื่อจุดติดตั้ง"
          @click="$refs.editName.sendInfo($route.query.pj_code, modalID)"
        >
          <feather-icon
            icon="EditIcon"
            size="18"
          />
        </b-link>
      </span>
      <span
        v-else
        style="font-size: 20px;"
      >จุดติดตั้งทั้งหมด</span>
    </div>
    <b-row>
      <b-col
        lg="4"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1"
      >
        <label>ค้นหา</label>
        <b-input-group
          size="sm"
          style="padding-left:14px;"
        >
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="ป้อนคำค้นหา"
            label-cols-sm="12"
            label-cols-md="2"
            label-cols-lg="2"
            style=" background-color:rgba(0,0,0, 0.6);"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              ล้าง
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col
        cols="8"
        class="d-flex align-items-center justify-content-end mb-1"
      >
        <a>
          <b-button
            id="EquipmentAdd"
            v-b-modal="'EquipmentAdd'+modalID"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon
              icon="PlusCircleIcon"
              size="24"
              class="mr-1"
            />
            <label style="color:white; font-size: 14px;">เพิ่มอุปกรณ์</label>
          </b-button>
        </a>
      </b-col>
      <b-col
        cols="12"
        class="mb-1"
      >
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(live)="data">
            <b-link
              v-if="data.item.RTSP_HLS"
              v-b-modal="'Live' + modalID"
              @click="$refs.RTSP.streamLive(data.item.RTSP_HLS)"
            >
              <b-img
                src="@/assets/images/icons/Live.svg"
              />
            </b-link>
          </template>
          <template
            #cell(edit)="data"
          >
            <b-link
              v-b-modal="'EquipmentEdit'+ modalID"
              @click="$refs.childref.sendInfo(data.item.ipaddress)"
            ><b-img
              src="@/assets/images/icons/Edit.svg"
            />{{ data.value }}
            </b-link>
            <b-link
              @click.prevent="remove(data.item.ipaddress)"
            >
              <b-img
                src="@/assets/images/icons/Delete.svg"
              />
              {{ data.value }}
            </b-link>
          </template>
          <template #cell(ISOnline)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </b-col>
      <b-col
        cols="12"
      >
        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
      <SumEquipmentAdd
        :id-data="modalID"
        :data="optionsLocal"
        @fetch="getSumEquipment(optionsLocal.location_id)"
      />
      <SumEquipmentEdit
        ref="childref"
        :id-data="modalID"
        @fetch="getSumEquipment(optionsLocal.location_id)"
      />
      <Live
        ref="RTSP"
        :id-data="modalID"
      />
      <LocationNameEdit
        ref="editName"
        :id-data="modalID"
        @fetch="getSumEquipment(optionsLocal.location_id)"
      />
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BTable, BPagination, BFormGroup, BFormSelect, BCardBody,
  BInputGroup, BInputGroupAppend, BFormInput, BButton, BImg, BLink, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import SumEquipmentAdd from './SumEquipmentAdd.vue'
import SumEquipmentEdit from './SumEquipmentEdit.vue'
import LocationNameEdit from './LocationNameEdit.vue'
import Live from './Live.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BButton,
    BImg,
    BLink,
    BBadge,
    SumEquipmentAdd,
    SumEquipmentEdit,
    LocationNameEdit,
    Live,
  },
  directives: {
    Ripple,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.projectData)),
      fields: [
        {
          key: 'type',
          label: 'ประเภท',
          class: 'text-center',
        },
        {
          key: 'Camera_Desc',
          label: 'Hostname',
          class: 'text-center',
        },
        {
          key: 'crossingIndexCode',
          label: 'CrossingIndexCode',
          sortable: true,
        },
        {
          key: 'LastUpdate',
          label: 'อัพเดตล่าสุด',
          sortable: true,
        },
        {
          key: 'ISOnline',
          label: 'สถานะ',
        },
        {
          key: 'live',
          label: 'Live',
        },
        {
          key: 'edit', label: 'จัดการ', requiresAdmin: true, class: 'text-center',
        },
      ],
      status: [{
        1: 'Online', 0: 'Offline',
      },
      {
        1: 'success', 0: 'danger',
      }],
      items: [],
      perPage: 50,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      modalID: 0,
      locationName: '',
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumEquipment(this.optionsLocal.location_id)
  },
  methods: {
    getSumEquipment(id) {
      this.modalID = this.optionsLocal.location_id
      axios
        .post('/tableEquipment', { pj_code: this.$route.query.pj_code, location_id: id })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          if (this.modalID) {
            this.fetchLocation()
          }
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchLocation() {
      axios
        .post('/fetchELocation', {
          pj_code: this.$route.query.pj_code,
          location_id: this.modalID,
        })
        .then(response => {
          this.locationName = response.data.location_name
        })
        .catch(error => {
          console.log(error)
        })
    },
    remove(ipaddress) {
      this.$swal({
        title: '<span style="color:#000000">ต้องการลบข้อมูลหรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await axios.post('/deleteEquipment', { pj_code: this.$route.query.pj_code, ipaddress })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ลบข้อมูลเรียบร้อย.</span>',
              // text: 'Deleted successfully.',
              showConfirmButton: false,
              timer: 1000,
            })
            this.getSumEquipment(this.optionsLocal.location_id)
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' You clicked the button!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
